<div class="card card-statistics mb-30">
  <div class="card-body">
      <h5 class="card-title">Calibration Certificate Upload Form</h5>

      <br>
      <div class="row">
        <div class="col-md-4">
          <div class="card card-statistics h-100">
            <div class="card-body">
              <div class="clearfix">
                <div class="float-left icon-box bg-success rounded-circle">
                  <span class="text-white">
                    <i class="fa fa-certificate highlight-icon" aria-hidden="true"></i>
                  </span>
                </div>
                <div class="float-right text-right">
                  <p class="card-text text-dark">  Uploaded Calibration Certificate Count <b>Current Month</b> </p>
                  <h4>{{current_Year}}</h4>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="card card-statistics h-100">
            <div class="card-body">
              <div class="clearfix">
                <div class="float-left icon-box bg-info rounded-circle">
                  <span class="text-white">
                    <i class="fa fa-certificate highlight-icon" aria-hidden="true"></i>
                  </span>
                </div>
                <div class="float-right text-right">
                  <p class="card-text text-dark">Uploaded Calibration Certificate Count <b>Previous Month</b></p>
                  <h4>{{last_Month}}</h4>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="card card-statistics h-100">
            <div class="card-body">
              <div class="clearfix">
                <div class="float-left icon-box bg-warning rounded-circle">
                  <span class="text-white">
                    <i class="fa fa-certificate highlight-icon" aria-hidden="true"></i>
                  </span>
                </div>
                <div class="float-right text-right">
                  <p class="card-text text-dark">Uploaded Calibration Certificate Count <b>Current Year</b> </p>
                  <h4>{{current_Month}}</h4>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <br>
      <br>


      <button type="button" (click)="openModal_Customer(templateCustomer)" class="btn btn-warning" style="margin-right: 5px;"> Search Customer  <i class="fa fa-vcard"></i> </button>

      <div *ngIf="Data_Seleted_Customer.id>0">
          <form  >
            <br/>
            <br/>
            <div class="row">
              <div class="form-group col-md-6">
                <label for="exampleInputEmail1">Customer Code  </label>
                <input type="text" class="form-control" disabled value="{{Data_Seleted_Customer.code}}" />
              </div>
              <div class="form-group col-md-6">
                <label for="exampleInputEmail1">Behfa Customer Name  </label>
                <input type="text" class="form-control" disabled value="{{Data_Seleted_Customer.name}}" />
              </div>
            </div>
          </form>

          <button  type="button" (click)="openModal_ExpertCalibration(templateExpertCalibration)" class="btn btn-danger" style="margin-right: 5px;"> Search Calibration Technician   <i class="fa fa-user-circle-o"></i> </button>
          <form *ngIf="Data_Seleted_ExpertCalibration.id>0" >
            <br/>
            <br/>
            <div class="row">
              <div class="form-group col-md-6">
                <label for="exampleInputEmail1"> First Name  </label>
                <input type="text" class="form-control" disabled value="{{Data_Seleted_ExpertCalibration.name}}" />
              </div>
              <div class="form-group col-md-6">
                <label for="exampleInputEmail1">Last Name  </label>
                <input type="text" class="form-control" disabled value="{{Data_Seleted_ExpertCalibration.familly}}" />
              </div>
            </div>
            <div *ngIf="Data_Seleted_Certificate.length==0">
              <div class="row">
                <div class="form-group col-md-12">
                    <label for="exampleInputEmail1"> Select File </label>
                    <input #file  multiple type="file" class="form-control" >
                </div>
              </div>
              <img *ngIf="ProcssingUpload" src="assets/Loading.gif" style="width: 25px;" />
              <button  *ngIf="!ProcssingUpload" type="button" (click)="upload(file.files)"  class="btn btn-info" style="margin-right: 5px;"><i class="fa  fa-upload"></i> Upload File </button>
            </div>
            <div *ngIf="Data_Seleted_Certificate.length!=0">
              <br/>
              <br/>
              <h3>Calibration Certificates</h3>
              <br/>
              <br/>
              <div class="row">
                <div class="form-group col-md-6">
                  <label for="exampleInputEmail1">Reason</label>
                  <select [(ngModel)]="FormUploader_elat" name="FormUploader_elat" class="custom-select" >
                    <option value="1">Damaged</option>
                    <option value="2">Missing Required Accessories</option>
                    <option value="3">Customer Declined Service</option>
                    <option value="4">Other</option>
                  </select>
                </div>
                <div class="form-group col-md-6">
                  <label for="exampleInputEmail1">Number of Returned Equipment Items</label>
                  <input [(ngModel)]="FormUploader_tedad_bargashti" name="FormUploader_tedad_bargashti" type="number" class="form-control"  placeholder="Type here to search...">
                </div>
              </div>

              <div class="table-responsive">
                <table class="mb-0 table table-bordered table-3 text-center table-striped">
                  <thead style="background-color: #489b39; color: white;">
                    <tr>
                      <th>#</th>
                      <th>Certificate No</th>
                      <th>Calibration Date</th>
                      <th>Recal. Date</th>
                      <th>ID</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let item of Data_Seleted_Certificate">
                     <td>{{Data_Seleted_Certificate.indexOf(item)+1}}</td>
                      <td>{{item.certificate_no}}</td>
                      <td>{{item.calibration_date}}</td>
                      <td>{{item.recal_date}}</td>
                      <td>
                        <button type="button" (click)="openModal_Recipt(templateRecipt,Data_Seleted_Certificate.indexOf(item))" style="margin-right: 10px;" class="btn btn-danger"> Search ID   </button>

                        <input disabled *ngIf="item.device_code" type="text" [value]="item.device_code" />
                      </td>
                      <td style="cursor: pointer;">
                        <a style="cursor: pointer;" (click)="Certificate_Delete(Data_Seleted_Certificate.indexOf(item))" class="dropdown-item" ><i class="fa fa-remove"></i> Delete </a>
                      </td>

                    </tr>
                  </tbody>
                </table>
             </div>


              <img *ngIf="InProccessing" src="assets/Loading.gif" style="width: 25px;" />
              <button *ngIf="!InProccessing" (click)="openModal_FinishForm(templateFinishForm)" type="button"   class="btn btn-success" style="margin-right: 5px;"><i class="fa  fa-plus-circle"></i> Register Information </button>
            </div>

          </form>
      </div>

  </div>
</div>

<ng-template #templateCustomer>
  <div class="modal-header">
     <h4 class="modal-title pull-left">Customer List  </h4>
     <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Customer.hide()">
        <span aria-hidden="true">×</span>
     </button>
  </div>
  <div class="modal-body">
    <div class="card-body">
      <div class="row">
        <div class="form-group col-md-12">
            <label for="exampleInputEmail1">Customer Name  </label>
            <input  type="text" class="form-control" (keyup)="ReadData_Customer_KeySearch()"  [(ngModel)]="Search_CodeName_Customer_Table"  placeholder="Type here to search...">
        </div>
      </div>

      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>Behfa Customer Code</th>
              <th>Customer Name</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList_Customer
            | paginate
                    : {
                        id: 'DataList_Customer',
                        itemsPerPage: 10,
                        currentPage: Customerpage,
                        totalItems: (DataList_Customer).length
                      }">
              <td>{{DataList_Customer.indexOf(item)+1}}</td>
              <td>{{item.code}}</td>
              <td>{{item.name}}</td>
              <td (click)="Set_Selected_Customer_Record(item)" style="cursor: pointer;">
                <button class="btn btn-info"><i class="fa fa-check"></i> Select</button>
              </td>

            </tr>
          </tbody>
        </table>
    </div>
  </div>
 </div>
  <div class="modal-footer">
    <img *ngIf="ProcssingCustomer" src="assets/Loading.gif" style="width: 25px;" />
    <button  *ngIf="!ProcssingCustomer" type="button" (click)="ReadData_Customer()"  class="btn btn-info" style="margin-right: 5px;"><i class="fa  fa-search"></i> Search </button>
     <button type="button" class="btn btn-danger" (click)="modalRef_Customer.hide()">Close</button>
  </div>
</ng-template>

<ng-template #templateRecipt>
  <div class="modal-header">
     <h4 class="modal-title pull-left">Equipment List  </h4>
     <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Recipt.hide()">
        <span aria-hidden="true">×</span>
     </button>
  </div>
  <div class="modal-body">
    <div class="card-body">
      <div class="row">
        <div class="form-group col-md-12">
          <label for="exampleInputEmail1">Instrument Code</label>
          <input [(ngModel)]="Filter_Device_Code" (keyup)="Change_Filter_Device_Code()" name="Filter_Device_Code" type="text" class="form-control"  placeholder="Type here to search...">
        </div>
        <div class="form-group col-md-12">
          <label for="exampleInputEmail1">Instrument Name</label>
          <input [(ngModel)]="Filter_Device_Name" (keyup)="Change_Filter_Device_Code()" name="Filter_Device_Name" type="text" class="form-control"  placeholder="Type here to search...">
        </div>
      </div>
      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>Receipt Number</th>
              <th>Instrument Name</th>
              <th>Instrument Code</th>
              <th>Instrument Serial Number</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList_Calibration
            |filter:Filter_Device_Code:'device_code'
            |filter:Filter_Device_Name:'device_name'
            | paginate
                    : {
                        id: 'DataList_Recipt',
                        itemsPerPage: 20,
                        currentPage: Calibrationpage,
                        totalItems: (
                          DataList_Calibration
                          |filter:Filter_Device_Code:'device_code'
                          |filter:Filter_Device_Name:'device_name'
                          ).length
                      }">
              <td>{{DataList_Calibration.indexOf(item)+1}}</td>
              <td>{{item.dsc}}</td>
              <td>{{item.device_name}}</td>
              <td>{{item.device_code}} </td>
              <td>{{item.device_serial}} </td>
              <td (click)="Set_Selected_Calibration_Record(item)" style="cursor: pointer;">
                <button class="btn btn-info"><i class="fa fa-check"></i> Select</button>
              </td>

            </tr>
          </tbody>
        </table>
    </div>
  </div>
 </div>
  <div class="modal-footer">
    <img *ngIf="Procssing_Recipt" src="assets/Loading.gif" style="width: 25px;" />
    <button  *ngIf="!Procssing_Recipt" type="button" (click)="Read_Calibration()"  class="btn btn-info" style="margin-right: 5px;"><i class="fa  fa-search"></i> Search </button>
     <button type="button" class="btn btn-danger" (click)="modalRef_Recipt.hide()">Close</button>
  </div>
</ng-template>

<ng-template #templateExpertCalibration>
  <div class="modal-header">
     <h4 class="modal-title pull-left">Calibration Technician List  </h4>
     <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_ExpertCalibration.hide()">
        <span aria-hidden="true">×</span>
     </button>
  </div>
  <div class="modal-body">
    <div class="card-body">
      <div class="row">
        <div class="form-group col-md-12">
          <label for="exampleInputEmail1">Last Name</label>
          <input [(ngModel)]="Filter_Familly" (keyup)="Change_Filter()" name="Filter_Familly" type="text" class="form-control"  placeholder="Type here to search...">
        </div>
      </div>

      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>First Name</th>
              <th>Last Name</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList_ExpertCalibration
            |filter:Filter_Familly:'familly'
            | paginate
                    : {
                        id: 'DataList_FeildTable',
                        itemsPerPage: 10,
                        currentPage: ExpertCalibrationpage,
                        totalItems: (DataList_ExpertCalibration
                        |filter:Filter_Familly:'familly'
                        ).length
                      }
            ">
             <td>{{DataList_ExpertCalibration.indexOf(item)+1}}</td>
              <td>{{item.name}}</td>
              <td>{{item.familly}}</td>
              <td (click)="Set_Selected_ExpertCalibration_Record(item)" style="cursor: pointer;">
                <button class="btn btn-info"><i class="fa fa-check"></i> Select</button>
              </td>

            </tr>
          </tbody>
        </table>
     </div>
  </div>
 </div>
  <div class="modal-footer">
    <img *ngIf="Procssing_ExpertCalibration" src="assets/Loading.gif" style="width: 25px;" />
    <button  *ngIf="!Procssing_ExpertCalibration" type="button" (click)="ReadData_ExpertCalibration()"  class="btn btn-info" style="margin-right: 5px;"><i class="fa  fa-search"></i> Search </button>
     <button type="button" class="btn btn-danger" (click)="modalRef_ExpertCalibration.hide()">Close</button>
  </div>
</ng-template>

<ng-template #templateFinishForm>
  <div class="modal-header">
     <h4 class="modal-title pull-left"> Confirm Final Submission  </h4>
     <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_FinishForm.hide()">
        <span aria-hidden="true">×</span>
     </button>
  </div>
  <div class="modal-body">
    <p>Are you sure the number of uploaded calibration certificates is correct?</p>
  </div>
  <div class="modal-footer">
    <button (click)="SubmitCertificate()" type="button" class="btn btn-info" style="margin-right: 5px;"><i class="fa  fa-plus"></i> Confirm and Finalize </button>
    <button type="button" class="btn btn-danger" (click)="modalRef_FinishForm.hide()">Close</button>
  </div>
</ng-template>
